<div *ngIf="areas">
  <div class="bg-white pt-3 ml-2">
    <div class="text-bidit-primary font-weight-bold">Areas & Sub Areas:</div>
    <div class="row">
      <div class="col-sm-8">
        <span class="text-bidit-primary font-weight-bold">Areas</span> are grouped locations you install insulation into a project (Ceiling, walls, floor, basement). <span class="text-bidit-primary font-weight-bold">Sub Areas</span> determine the labor costs for a quote. You may add or modify both below.
      </div>
      <div class="col-sm-4 float-right">
        <div>
          <a (click)="showAreaSourceEdit(null)" class="btn btn-bidit-navigate btn-md mb-sm-3">Add New Area</a>
        </div>
        <div>
          <a (click)="showSubAreaEdit(null)" class="btn btn-bidit-navigate btn-md mb-sm-3">Add New Sub Area</a>
        </div>
      </div>
    </div>
    <div *ngFor="let area of areas">
        <div class="form-inline area-header mt-3">
            <a (click)="showAreaSourceEdit(area.area_ID)" class="btn-bidit-edit-dark"></a>
            <span class="text-bidit-primary font-weight-bold ml-1 mr-5">Area: {{area.area_Name}}</span>
            <div class="form-inline">
                <label id="area_status_active{{area.area_ID}}" [ngClass]="{'text-success' : area.area_IsActive}">active</label>
                <input (change)="toggleAreaStatus('IDIAreaSource', area.area_ID)" type="checkbox" name="area_status_{{area.area_ID}}"
                       id="area_status{{area.area_ID}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!area.area_IsActive" (ngModelChange)="area.area_IsActive = $event" />
                <label id="area_status_inactive{{area.area_ID}}" [ngClass]="{'text-danger' : !area.area_IsActive}">inactive</label>
                <div *ngIf="area.area_IsOption" class="info-icon" i18n-matTooltip
                     matTooltip="Options area should not be inactivated."></div>
            </div>
        </div>
        <mat-table class="table compact table-bidit" [dataSource]="area.subAreas">
            <ng-container matColumnDef="subArea_Name">
                <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Sub Areas</mat-header-cell>
                <mat-cell *matCellDef="let subArea">
                    {{ subArea.subArea_Name}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Status</mat-header-cell>
                <mat-cell *matCellDef="let subArea">
                    <div class="form-inline">
                        <label id="subarea_status_active{{subArea.subArea_ID}}" [ngClass]="{'text-success' : subArea.subArea_IsActive}">active</label>
                        <input (change)="toggleSubAreaStatus('IDISubAreaSource', subArea.area_ID, subArea.subArea_ID)" type="checkbox" name="subarea_status_{{subArea.subArea_ID}}" id="subareastatus_{{subArea.subArea_ID}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!subArea.subArea_IsActive" (ngModelChange)="subArea.subArea_IsActive = $event">
                        <label id="subarea_status_inactive{{subArea.subArea_ID}}" [ngClass]="{'text-danger' : !subArea.subArea_IsActive}">inactive</label>
                        <span class="border-left-0 btn-bidit-edit-dark ml-5" (click)="showSubAreaEdit(subArea.subArea_ID)"></span>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
    </div>
  </div>
  </div>
